module.exports = __webpack_public_path__ + "img/word.6bf5d6e0.png";